import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function Markdown({ children }: { children: string }) {
  return (
    <div className="text-sm text-slate-700 leading-relaxed space-y-2">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ node, ...p }) => <h4 className="font-heading font-semibold text-slate-900 text-sm mt-2" {...p} />,
          h2: ({ node, ...p }) => <h4 className="font-heading font-semibold text-slate-900 text-sm mt-2" {...p} />,
          h3: ({ node, ...p }) => <h5 className="font-heading font-semibold text-slate-800 text-[13px] mt-2" {...p} />,
          p: ({ node, ...p }) => <p className="text-sm text-slate-700" {...p} />,
          ul: ({ node, ...p }) => <ul className="list-disc pl-5 space-y-1 text-sm text-slate-700" {...p} />,
          ol: ({ node, ...p }) => <ol className="list-decimal pl-5 space-y-1 text-sm text-slate-700" {...p} />,
          li: ({ node, ...p }) => <li className="text-sm text-slate-700" {...p} />,
          strong: ({ node, ...p }) => <strong className="font-semibold text-slate-900" {...p} />,
          em: ({ node, ...p }) => <em className="italic" {...p} />,
          a: ({ node, ...p }) => <a className="text-teal-700 underline" target="_blank" rel="noreferrer" {...p} />,
          code: ({ node, ...p }) => <code className="font-mono text-[12px] bg-slate-100 rounded px-1 py-0.5 text-slate-800" {...p} />,
          blockquote: ({ node, ...p }) => <blockquote className="border-l-2 border-slate-300 pl-3 text-slate-600 italic" {...p} />,
          table: ({ node, ...p }) => <table className="w-full text-xs border-collapse my-2" {...p} />,
          th: ({ node, ...p }) => <th className="border border-slate-200 bg-slate-50 px-2 py-1 text-left font-medium" {...p} />,
          td: ({ node, ...p }) => <td className="border border-slate-200 px-2 py-1" {...p} />,
          hr: () => <hr className="border-slate-200 my-2" />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
